import React from 'react';
import { Button } from '@/components/buttons/Button';
import { useIntl } from 'react-intl';

interface IdScanErrorProps {
  ctaOnClick: () => void;
}

const IdScanError = ({ ctaOnClick }: IdScanErrorProps) => {
  const intl = useIntl();
  return (
    <div
      data-cy="id-scan-error-text"
      className="flex flex-col items-center justify-center gap-y-8 h-full"
    >
      <h3 className="mt-0 mb-8">{intl.formatMessage({ id: 'error.support' })}</h3>
      <div className="mx-auto w-[70%]">
        <Button
          data-cy="id-scan-error-button"
          text={intl.formatMessage({ id: 'id-scan-modal.request-new-id-scan' })}
          onClickHandler={ctaOnClick}
        />
      </div>
    </div>
  );
};

export default IdScanError;
